<template>
    <v-container grid-list-sm text-xs-left>

        <v-layout row
                  wrap
                  pa-2
                  align-end>
            <v-flex xs12 py-2>
                <span class="display-2">Open Innovation Contest Challenges</span>
            </v-flex>
            <v-flex xs12 pb-4>
                <span class="headline">These are the challenges that have just been concluded for the Open Innovation Contest 11.</span>
                <br>
                <br>
                <span class="headline">Exploring this page you can see which startups are selected for each challenge and download the pdf of their proposal!</span>
                <br>
                <br>

            </v-flex>
        </v-layout>

        <v-layout
                row
                wrap
                pa-2
                align-end
        >
            <v-flex xs12 md4 pb0 mb0 >
                <span v-if="challangesFlag"
                      class="headline"
                >
                    Challenges
                </span>
                <span v-else
                      class="headline"
                >
                    No Challenge Found
                </span>
            </v-flex>
            <v-flex xs6 md4 class="pl-3">
                <v-text-field
                        class="pt-1"
                        v-model="search"
                        :append-icon="search?'close':'search'"
                        @click:append="search = ''"
                        label="Search"
                        single-line
                        hide-details
                        @keydown.native.escape="search=''">
                </v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex v-for="challenge in filteredItems"
                    :key="challenge._id"
                    xs12 sm6 md6 lg4 xl4
                    pa-2
            >
                <v-card>
                    <v-img
                            :lazy-src="require('@/assets/img/innovation/loadingBlueGreen.gif')"
                            :src="challangesImgs[challenge._id]"
                            aspect-ratio="2.75"
                            height="200px"
                    >
                    </v-img>

                    <v-card-title primary-title>
                        <v-flex xs12 class="headline block-ellipsis-title">{{challenge.Title.replace('OIC 11 ','')}}</v-flex>
                        <v-flex xs12 class="block-ellipsis-description" v-html="challenge.Description"></v-flex>
                        <v-flex xs12 class="block-ellipsis-tags">
                            <v-chip
                                    v-for="tag in challenge.tags"
                                    slot="activator"
                                    column
                                    disabled
                                    color="blue"
                                    outline>
                                {{ tag }}
                            </v-chip>
                        </v-flex>

                    </v-card-title>

                    <v-card-actions>
                        <v-btn
                                slot="activator"
                                color="blue"
                                flat
                                dark
                                class="elevation-0"
                                @click="navigate(challenge._id)"
                        >
                            Explore
                        </v-btn>
                        <v-tooltip color="amber lighten-4" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        slot="activator"
                                        color="blue"
                                        flat
                                        dark
                                        class="elevation-0"
                                        @click="openStartupRegisteredTreeViewDialog(challenge)"
                                        v-on="on"
                                >
                                    Startups
                                </v-btn>
                            </template>
                            <v-card color="amber lighten-4" elevation="0">
                                <v-card-title>
                                    <v-layout column wrap>
                                        <v-flex>
                                            <span class="subheading">Click here to see list of <strong>startups selected</strong> for this challenge.</span>
                                        </v-flex>
                                    </v-layout>
                                </v-card-title>
                            </v-card>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="challenge.selected  =! challenge.selected">
                            <v-icon>{{ challenge.selected ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-card-text v-show=challenge.selected>
                        <v-flex xs12><span class="font-weight-bold">Deadline: </span> {{challenge.date}} </v-flex>
                    </v-card-text>
                </v-card>
            </v-flex>


        </v-layout>

        <v-layout row
                  wrap
                  pa-2
                  mt-5
                  align-end>

            <v-flex xs12>
                <span class="headline"><strong>Discovery</strong> is the startup collaboration platform created by NTT DATA Innovation team for connecting the most innovative startups with our NTT DATA professionals and international clients.</span>
                <br>
                <br>
                <span class="headline">Find out more information about Discovery at this <a href="https://discovery.nttdataitalia.com/" target="_blank">link</a> and enter your contacts for booking a demo session.</span>
            </v-flex>
            <v-flex xs12 class="text-xs-center">
                <v-btn dark color="primary" @click="openContactsDialog">Enter contacts</v-btn>
            </v-flex>
        </v-layout>




        <!-- Contacts -->
        <v-dialog
                v-model="openContacts"
                max-width="1200"
                scrollable
        >
            <v-card>
                <v-card-title class="headline">Enter contacts</v-card-title>
                <v-card-text>

                <ContactsRegistrationGhost ref="form" @submit="openContacts=false"></ContactsRegistrationGhost>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="openContacts=false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- TreeView for Registered Startups -->
        <v-dialog
                v-model="startupRegisteredTreeViewDialog"
                max-width="1200"
                scrollable
        >
            <v-card>
                <v-card-title class="headline">Selected Startup</v-card-title>
                <v-card-text>
                    <span class="subheading">Click on startup's name to see details</span>
                    <StartupGhostTreeView :challenge='selectedChallenge'></StartupGhostTreeView>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="closeStartupRegisteredTreeViewDialog()"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import StartupGhostTreeView from "@/pages/Admin/GhostPage/StartupGhostTreeView";
    import ContactsRegistrationGhost from "@/pages/Admin/GhostPage/ContactsRegistrationGhost";

    export default {
        name: "GhostPage",
        components: {StartupGhostTreeView,ContactsRegistrationGhost},
        computed: {
            filteredItems() {
                let filtered = [];
                for (let i=0; i<this.challenges.length; i=i+1){
                    if(this.challenges[i].Title.toLowerCase().includes(this.search.toLowerCase())){
                        filtered.push(this.challenges[i]);
                    }
                }

                filtered.sort(function(a, b){
                    var keyA = new Date(a.datePublished),
                        keyB = new Date(b.datePublished);
                    // Compare the 2 dates
                    if(keyA > keyB) return -1;
                    if(keyA < keyB) return 1;
                    return 0;
                });

                return filtered;
            },
        },
        data() {
            return {
                header: "Challenges",
                challenges: [],
                challangesImgs: {},
                challangesFlag: false,
                selectedChallenge: {},
                search: "",
                startupRegisteredTreeViewDialog: false,
                openContacts: false
            };
        },
        created() {
            this.getChallenges();
        },
        methods: {
            openContactsDialog(){
                this.openContacts=true
                this.$refs.form.setCheckbox(false);
            },
            getRequireImg(path){
                return require(path)
            },
            navigate(id) {
                let path = {
                    name: "GhostChallengeDetails",
                    params: {
                        _id: id,
                    },
                };
                RouterService.goTo(path);
            },
            closeStartupRegisteredTreeViewDialog() {
                this.selectedChallenge = {};
                this.startupRegisteredTreeViewDialog = false;
            },
            openStartupRegisteredTreeViewDialog(challenge) {
                this.selectedChallenge = challenge;
                this.startupRegisteredTreeViewDialog = true;
            },
            getChallenges() {
                let requestUrl = {
                    url: UrlsService.challengesGhost,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text:"LIST"
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Challenges",
                    loading: "Waiting for list of challenges...",
                    error: "Cannot get challenges...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.challenges = [];
                        let responseChallenges = responseSuccess.response.challengesGhost;

                        for (let i = 0; i < responseChallenges.length; i++) {
                            responseChallenges[i]['selected'] = false
                            this.challenges.push(responseChallenges[i])
                            this.downloadImage(responseChallenges[i]._id)
                        }

                        if(this.challenges.length == 0){
                            this.challangesFlag = false
                        }
                        else{
                            this.challangesFlag = true
                        }
                    });
            },
            downloadImage(idImg){
                let requestUrl = {
                    url: UrlsService.challengeOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "GET_IMAGE",
                        challengeRequest: {
                            challenge: {
                                _id: idImg
                            },
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Challenges Images",
                    loading: "Waiting for list of images challenges...",
                    error: "Cannot get challenges images...",
                };
                let options = {
                    loadingType: "silent",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let responseImage = responseSuccess.response.challenges[0];
                        this.challangesImgs[idImg] = responseImage.imgBase64;
                        this.$forceUpdate();
                    });
            },
        },
    }
</script>

<style scoped>

    .ellipsis {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .block-ellipsis-title {
        display: block;
        display: -webkit-box;
        max-width: 100%;
        height: 35px;
        margin: 0 auto 0 0;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: hidden; /* auto (for vertical scrolling) or hidden */
    }

    .block-ellipsis-description {
        display: block;
        display: -webkit-box;
        max-width: 100%;
        height: 63px;
        margin: 0 auto 0 0;
        font-size: 14px;
        line-height: 1.5;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: hidden; /* auto (for vertical scrolling) or hidden */
    }

    .block-ellipsis-tags {
        display: block;
        display: -webkit-box;
        max-width: 100%;
        height: 84px;
        margin: 0 auto 0 0;
        line-height: 1.5;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: auto; /* auto (for vertical nad orizontal scrolling) or hidden */
    }

    .my-span {
        background-color: white;
        opacity: 0.5;
        color: black;
        font-weight: bold;
        margin-right: 5%;
        margin-top: 2.5%;
        float: right;
    }

</style>